// extracted by mini-css-extract-plugin
export default {"searchPage":"SearchPage_searchPage__tMudc","header":"SearchPage_header__RTuvm","resultBlock":"SearchPage_resultBlock__bRIks"};